import { authMutations } from '@/queries/auth'

let refreshPromise: ReturnType<ReturnType<typeof authMutations.refresh>['mutationFn']> | null = null

export const refreshSessionOnce = () => {
  refreshPromise ??= authMutations
    .refresh()
    .mutationFn()
    .finally(() => {
      refreshPromise = null
    })
  return refreshPromise
}
